/**
 * RefundSlice Approvals Reducers
 * 
 * Handles approval operations.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RefundSliceState } from '../state';
import { ApprovalView } from '../../types/refundTypes';

// Helper function to add field to edited fields array without duplicates
const addEditedField = (state: RefundSliceState, fieldName: string) => {
  if (!state.editedFields.includes(fieldName)) {
    state.editedFields.push(fieldName);
  }
  state.isEdited = true;
};

/**
 * Add an approval
 */
export const addApproval: CaseReducer<RefundSliceState, PayloadAction<ApprovalView>> = (
  state,
  action
) => {
  if (state.currentRefund) {
    state.currentRefund.approvals.push(action.payload);
    addEditedField(state, 'approvals');
  }
};

/**
 * Update an existing approval by level
 */
export const updateApproval: CaseReducer<
  RefundSliceState,
  PayloadAction<{ level: number; updates: Partial<ApprovalView> }>
> = (state, action) => {
  if (state.currentRefund) {
    const approvalIndex = state.currentRefund.approvals.findIndex(
      approval => approval.level === action.payload.level
    );
    if (approvalIndex !== -1) {
      state.currentRefund.approvals[approvalIndex] = {
        ...state.currentRefund.approvals[approvalIndex],
        ...action.payload.updates
      };
      addEditedField(state, 'approvals');
    }
  }
};
